import { defineComponent as _defineComponent } from 'vue'
import FormContainer from "../shared/FormContainer.vue"
import { inject, Ref, computed } from "vue"
import PasswordForm from "./PasswordForm.vue"
import { AHEAD_THEME, ProductTypeEnum } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordFormContainer',
  props: {
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  hasPreviousSteps: {
    type: Boolean,
    default: false,
  },
  submitBtnLabel: {
    type: String,
    default: "Create Password",
  },
},
  emits: ["gotoNext", "gotoPrev", "updatePassword"],
  setup(__props, { emit }) {



const productType = inject("productType") as Ref<ProductTypeEnum>

const isAheadClient = computed(() => productType.value === ProductTypeEnum.Ahead)



const onConfirmPassword = async (password: string) => {
  emit("gotoNext")
  emit("updatePassword", password)
}

const gotoPrev = async () => {
  emit("gotoPrev")
}

return { __sfc: true,productType, isAheadClient, emit, onConfirmPassword, gotoPrev, FormContainer, PasswordForm, AHEAD_THEME }
}

})